export default {
      id: "ic-plan-public-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ic-plan-public-usage",
      toString: function () {
        return this.url;
      }
    }